<template>
    <div class="template-selector">
        <div class="item-wrapper">
            <span class="label">{{ $t("integrations.whatsappBusinessApiLabel") }}</span>

            <a-select
                v-model="clone.channel"
                style="width: 100%"
                :placeholder="$t('integrations.selectWhatsappBusinessChannelPlaceholder')"
            >
                <a-select-option v-for="channel in whatsappBusinessChannels" :key="channel._id" :value="channel._id">
                    {{ channel.name }}
                </a-select-option>
            </a-select>
        </div>
        <TemplateMessageSelector
            :channel-id="clone.channel"
            v-if="clone.channel"
            v-model="clone"
            field-mode
            :default-fields="fields"
        />
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import TemplateMessageSelector from "../../../../Whatsapp/pages/broadcast/create/TemplateMessageSelector.vue";
import TicimaxAttributes from "./filter/TicimaxAttributes";
import _ from "lodash";

export default Vue.extend({
    name: "TemplateSelector",
    components: { TemplateMessageSelector },
    props: {
        value: {
            required: true,
        },
        types: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            clone: {},
            fields: TicimaxAttributes(this.types).map((x) => ({
                id: x.value,
                label: x.name,
            })),
        };
    },
    computed: {
        ...mapState({
            whatsappBusinessChannels: (state) =>
                state.channel.channels.filter((x) => x.type === "whatsapp-business-api"),
        }),
    },
    created() {
        console.log("created", this.value);
        this.clone = _.cloneDeep(this.value);
    },
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
    },
    watch: {
        clone: {
            handler: function (val) {
                this.$emit("input", val);
            },
            deep: true,
        },
        value: {
            handler: function (val) {
                if (!_.isEqual(val, this.clone)) {
                    if (val) this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.template-selector {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    .item-wrapper {
        display: flex;
        gap: 10px;
        align-items: center;
        width: 100%;

        .label {
            font-weight: 700;
            width: 200px;
        }
    }
}
</style>
